import axios from "axios";


const api = axios.create({
    baseURL:"https://portalclientes.sinergy.lat/modules/Api/"
});

export default api;